// extracted by mini-css-extract-plugin
export default {"container":"notification_content-module__container--1dkjP"};